import { createAction } from '@reduxjs/toolkit';

export const setUserInfo = createAction('user/set_user_info');
